import Pagination from "react-js-pagination";

export const PaginationComponent = ({ onChangeHandle, pageNumber, pageCount }) => {
    return (
        <>
            <div className="d-flex justify-content-center">
                <Pagination
                    activePage={pageNumber}
                    itemsCountPerPage={10}
                    totalItemsCount={Math.ceil(pageCount / 5) * 5}
                    pageRangeDisplayed={3}
                    onChange={onChangeHandle}
                    activeLinkClass='active'
                    itemClass='page-item'
                    // hideNavigation
                    // hideFirstLastPages
                    linkClass="page-link"
                    prevPageText='prev'
                    nextPageText='next'
                />
            </div>
        </>
    )
}